const styleOverrides = {
  circleDeterminate: {
    strokeLinecap: 'round'
  }
};
export default {
  styleOverrides
};
//# sourceMappingURL=MuiCircularProgress.js.map